<template>
    <div id="skill">
      <myhead></myhead>
      <div class="bar">
	  		<router-link to="/">Fountain-scientific Home Page</router-link>
      		<span>></span>
      		<router-link to="/skill">FAQ's</router-link>
	  </div>
	  <div class="box">
			<p class="title">FAQ's</p>
			<div class="content">
				<div class="h">
					First of all, thank you for your trust and support to our company. Please leave your contact information so that we can come back to you on time. Thank you very much.
				</div>
				<form action="post" name="bForm">
					<div class="inputBox">
						<p>Name*</p>
						<input type="text" name="company_name"
						v-model="updata.company_name">
					</div>
					<div class="inputBox">
						<p>Company</p>
						<input type="text" name="contact_name"
						v-model="updata.contact_name">
					</div>
					<div class="inputBox">
						<p>Phone*</p>
						<input type="text" name="phone"
						v-model="updata.phone">
					</div>
					<div class="inputBox">
						<p>Country</p>
						<input type="text" name="email"
						v-model="updata.email">
					</div>
					<div class="inputBox">
						<p>E-mail*</p>
						<input type="text" name="product_name"
						v-model="updata.content">
            <!-- content为邮箱 -->
					</div>
					<div class="inputBox">
						<p>Product </p>
						<input type="text" name="content"
						v-model="updata.product_name">
					</div>	
					<div class="inputBox">
						<p>Question Description*</p>
						<input type="text" name="spec_email"
						v-model="updata.spec_email">
					</div>				
				</form>
				<div class="btn" @click="skill">Submit</div>
		    </div>
	  </div>
    </div>
</template>

<script>
import axios from "axios";
import myhead from "./common/header.vue";
const url = require("../url").url;
export default {
  name: "Skill",
  components: {
    myhead
  },
  data() {
    return {
      updata: {
        company_name: "",
        contact_name: "",
        phone: "",
        email: "",
        product_name: "",
        content: "",
        spec_email: ""
      }
    };
  },
  methods: {
    skill() {
      let self = this;
      if (
        !this.updata.company_name ||
        !this.updata.contact_name ||
        !this.updata.phone ||
        !this.updata.email ||
        !this.updata.product_name ||
        !this.updata.content ||
        !this.updata.spec_email
      ) {
        alert("Please perfect the infomation!");
      } else {
        let formData = new FormData();
        // content 为邮箱
        formData.append("company_name", this.updata.company_name);
        formData.append("contact_name", this.updata.contact_name);
        formData.append("email", this.updata.email);
        formData.append("phone", this.updata.phone);
        formData.append("product_name", this.updata.product_name);
        formData.append("spec_email", this.updata.spec_email);
        formData.append("content", this.updata.content);
        axios
          .post(url.skill, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(function(res) {
            // alert("申请成功，请耐心等待回复")
            console.log(res);
            self.$router.push("/");
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  },
  created() {
    if (this.$route.query.name) {
      this.updata.product_name = this.$route.query.name
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../assets/css/style.less");

.bar {
  height: 30px;
  line-height: 30px;
  text-align: left;
  font-size: 14px;
  padding: 0 10%;
  margin: 20px 0;
}
.bar > span {
  margin: 0 10px;
}
.box {
  padding: 0 10%;
  margin-bottom: 50px;
}
.title {
  height: 40px;
  color: #fff;
  line-height: 40px;
  background-color: @indexTheme;
}
.content {
  box-sizing: border-box;
  background-color: #eeeeee;
  height: 600px;
  padding: 30px 50px;
}
.h {
  border-bottom: 1px #ccc dotted;
  line-height: 40px;
  height: 40px;
  margin-bottom: 50px;
  text-align: left;
  font-size: 14px;
}
.inputBox > p {
  width: 200px;
  text-align: left;
}
.inputBox > input {
  width: 420px;
  height: 32px;
  box-sizing: border-box;
}
.inputBox {
  box-sizing: border-box;
  display: flex;
  margin: 20px 0;
  align-items: center;
  padding-left: 100px;
}
.btn {
  margin: 50px auto;
  width: 156px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  // background-color: #cd000f;
  background-color: @indexTheme;
}
</style>



// WEBPACK FOOTER //
// src/components/skill.vue